import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Perdés tiempo valioso buscando material que casi nunca tiene ejemplos argentinos', 'Tus alumnos se desconectan porque los ejemplos no tienen nada que ver con Argentina', 'No podés conectar la minería con la actualidad: litio de Jujuy, Josemaría, Cerro Negro, transición energética global', 'Tus evaluaciones son siempre las mismas porque no tenés un banco de ejercicios técnicos actualizados', 'Llegás al inicio del ciclo lectivo sin una secuencia didáctica completa lista para usar', 'Cuando surge el debate minería-ambiente no tenés datos técnicos reales para equilibrar el relato'];
  return <section className="py-20 bg-white" data-id="element-230">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-231">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-232">
          <h2 className="md:text-4xl font-extrabold text-forest-dark mb-6 text-balance text-[20px]" data-id="element-233">
            ❓ ¿Cuántas clases más vas a preparar sobre minería sin tener el
            material correcto?
          </h2>

          <div className="space-y-6 text-lg text-muted text-left md:text-center max-w-3xl mx-auto" data-id="element-234">
            <p className="text-[14px]" data-id="element-235">
              Buscás información en internet que no tiene secuencia didáctica ni
              menciona Argentina. Armás planificaciones desde cero cada ciclo
              lectivo. Y cuando un alumno pregunta sobre el litio de Cauchari,
              el proyecto Josemaría o por qué Argentina tiene el segundo
              reservorio de litio del mundo, no tenés una respuesta que los
              enganche con la realidad del país.
            </p>
            <p data-id="element-236">
              <strong className="text-forest-dark" data-id="element-237">
                No es falta de vocación docente. Es que nadie armó el sistema
                completo para vos.
              </strong>
            </p>
            <p className="font-bold text-forest-dark pt-4 text-[16px] pl-[10px]" data-id="element-238">
              😓 Esto te está pasando ahora mismo
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-red-50 border border-red-200 rounded-2xl p-6 md:p-8" data-id="element-239">
          <ul className="space-y-4" data-id="element-240">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-241">
                <div className="mt-1 bg-red-100 p-1 rounded-full shrink-0" data-id="element-242">
                  <X className="w-4 h-4 text-red-600" data-id="element-243" />
                </div>
                <span className="text-forest-dark font-medium" data-id="element-244">{problem}</span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-245">
          <p className="font-bold text-earth text-[18px]" data-id="element-246">
            ¿Y si esta fuera la última semana que enseñás minería sin tener todo
            resuelto?
          </p>
        </div>
      </div>
    </section>;
}